import React, { Fragment } from 'react';
import {Box,Grid,makeStyles,Typography} from '@material-ui/core';
import Hero from '../../Hero/Hero';
import FeaturedPost from '../../Home/CardContainer/Review';
import Header from '../../Header/Header';
import NavBar from '../../Header/Header2';

const useStyles= makeStyles({
    root:{
        marginTop:"40px",
        marginBottom:"30px"
    }
})

const featuredPosts = [
    {
      title: 'Allison Hargrvees',
      date: 'Nov 12',
      description:
        'I felt awsome xyz',
      image: 'https://source.unsplash.com/random',
      imageText: 'Image Text',
    },
    {
      title: 'Mr. Myagyi',
      date: 'Nov 11',
      description:
        'Some more text in here',
      image: 'https://source.unsplash.com/random',
      imageText: 'Image Text',
    },
    {
      title: 'Mr. Myagyi',
      date: 'Nov 21',
      description:
        'Some more text in here next',
      image: 'https://source.unsplash.com/random',
      imageText: 'Image Text',
    },
  ];

const AboutUs = () => {
    const classes = useStyles();
    return (
        <Fragment>
          <NavBar/>
            <Hero/>
            {/* <Grid container spacing={4} className={classes.root}>
            {featuredPosts.map((post) => (
              <FeaturedPost key={post.title} post={post} />
            ))}
          </Grid> */}

          <section className="pb-20  -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
              <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                      <i className="fas fa-award"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Organic Farm experience</h6>
                    <p className="mt-2 mb-4 text-gray-600">
                      Our campsite is surrounded by organic chia farm by our CSR partner kyarkifoundation.org.
                      Kyarki foundation is working with the Neer 's families of farmers to explore solutions to hill emigration. Their  mission is to bring about Sustainable Rural Development by informally promoting some of the United Nations SDGs for the villages they will adopt. Their  focus areas are Social Responsibility, Sustainable Agriculture, Education, Agrotourism, and Research.

                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                      <i className="fas fa-retweet"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Five Star Chef</h6>
                    <p className="mt-2 mb-4 text-gray-600">
                      We have partnered with our cousin brother who have been actively working in hospitality sector as chef from last decade.He has given his services in various five star hotels around the country.Due to covid - 19 pandemic he has lost his job which in turn ignited his entrepreneurial spirit and brings him to partner with us.Whatever he makes is always delicious and finger licking tasty.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-green-400">
                      <i className="fas fa-fingerprint"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Local Partners and Staff</h6>
                    <p className="mt-2 mb-4 text-gray-600">
                      We believe in supporting local community as much as possible.Working with locals increases the rural economy as well as opportunities of employment too.We
                      try to procure as much as possible to help sustain the local households from local selling their produce which will in the end help reduce our carbon footprint.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center mt-32">
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-gray-100">
                  <i className="fas fa-user-friends text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                  OUR PHILLOSOPHY
                </h3>
                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700">
                You came all the way to Rishikesh on a quest
                for a peaceful place to connect with yourself and only found a lot of noise, traffic and pollution ?



                </p>
                <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-gray-700">
                                  “
                                  Uddibaba” has been built to save your holiday in the world yoga capital.As one of the first agrotourism camping provider in the Uttarakhand Himalayas, we seek to promote sustainable practices that positively influence the local communities and the environment we interact with.
<br/>
                “
                Uddibaba” is the perfect place to relax in nature, enjoy the beautiful view of the serenic valley, connect with the local tribes, practice yoga and meditation, and interact with travellers and locals through events and retreats that we organise around the year.

                </p>
                
              </div>

              <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-blue-600">
                  <img
                    alt="..."
                    src="/asserts/images/total/image19.jpg"
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4 d-none">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-blue-600 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      Top Notch Services
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      The Arctic Ocean freezes every winter and much of the
                      sea-ice then thaws every summer, and that process will
                      continue whatever happens.
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="pt-20 pb-48">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center text-center mb-24">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold">Here are our heroes</h2>
                <p className="text-lg leading-relaxed m-4 text-gray-600">
                  According to the National Oceanic and Atmospheric
                  Administration, Ted, Scambos, NSIDClead scentist, puts the
                  potentially record maximum.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src="/asserts/images/total/image20.jpg"
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">AMIT PANWAR</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      CEO, CO-FOUNDER
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-blue-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </button>
                      <button
                        className="bg-pink-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-dribbble"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src = "/asserts/images/total/image21.jpg"
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">ANANT KHAROLA</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      CTO, CO-FOUNDER
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src = "/asserts/images/total/image22.jpg"
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">VIJAY PANWAR</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      EXECUTIVE CHEF
                        [PARTNER]

                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-gray-800 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-instagram"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src = "/asserts/images/total/image23.jpg"
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    < h5 className = "text-xl font-bold" > MOHAN NEGI</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                       OPERATIONS MANAGER
                         [PARTNER]
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-pink-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-dribbble"></i>
                      </button>
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-gray-800 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-instagram"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        </Fragment>
    );
}


export default AboutUs;